import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import styled from "styled-components";
import './App.css';


const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_ud8lmwi",
        "template_smgd892",
        form.current,
        "DgcDeUInrHpbiN5RV"
      )
      .then(
        (result) => {
          console.log(result.text);
          console.log("message sent");
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div contact-div>
        
        <StyledContactForm>
      <form ref={form} onSubmit={sendEmail}>
      <h1>Feedback</h1>
        <label>Name</label>
        <input type="text" name="user_name" />
        <label>Email</label>
        <input type="email" name="user_email" />
        <label>Message</label>
        <textarea name="message" />
        <input type="submit" value="Send" />
        <br/><br/><br/>
      </form>
        </StyledContactForm>
    </div>
    
  );
};

export default Contact;

// Styles
const StyledContactForm = styled.div`
  width: 400px;
  display: block;
  margin: 0 auto;
  

  
  form {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
    font-size: 16px;

    input {
      width: 100%;
      height: 35px;
      padding: 7px;
      outline: none;
      border-radius: 5px;
      border: 1px solid rgb(220, 220, 220);

      &:focus {
        border: 2px solid rgba(0, 206, 158, 1);
      }
    }

    h1{
        margin: 0 auto;
        font-size: 3rem; /* Change the font size of h1 */
    }

    textarea {
      max-width: 100%;
      min-width: 100%;
      width: 100%;
      max-height: 100px;
      min-height: 100px;
      padding: 7px;
      outline: none;
      border-radius: 5px;
      border: 1px solid rgb(220, 220, 220);

      &:focus {
        border: 2px solid rgba(0, 206, 158, 1);
      }
    }

    label {
      margin-top: 1rem;
    }

    input[type="submit"] {
      margin-top: 2rem;
      cursor: pointer;
      background: rgb(249, 105, 14);
      color: white;
      border: none;
    }
    
  }
  
`;